module.exports = __webpack_public_path__ + "static/media/icon_comment_off.ce7172c0.svg";